<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/MCSZeL/images/cover.jpg?1685327484826" alt="This image is the cover for the book Eartha Gets Well"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Eartha Gets Well
      </h1>
      <p class="bookDescription body article font2">
        <p>Is it a struggle to get your kids to eat healthy, want to be active, and get outside for fresh air and exercise? Then introduce them to Eartha! Winner of a 2012 Moonbeam Bhildren's Book Award, "Eartha Gets Well" is a story about a little girl who never exercised, didn’t like vegetables, and was always sick. Eartha learns how to make herself, her family, and the Earth feel better! Throughout her adventure, she realizes that she can be healthy and happy by making a few simple changes. When she realizes how easy and fun it is, she wants to tell everybody!</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Kristi Falk
      </h2>
      
      <p class="authorDescription body article">Kristi and Dr. Daniel Falk, residents near Myrtle Beach, South Carolina, are dedicated to spreading the message of total wellness. Kristi is the founder and executive director of The Wellness Council for South Carolina, a nonprofit organization focused on improving the health and wellness of the community at large, as well as the environment. Daniel is a highly respected chiropractic physician. He serves as the president of the Board of Directors for The Wellness Council for South Carolina and is the 2012-2013 president of the South Carolina Chiropractic Association. Both Kristi and Daniel want to educate and inspire the next generation to make healthier, greener, and more natural choices to ensure a better future for all.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      BQB Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?57b74d04